import { reportClientError } from '../errors/report-client-error.js';

/**
 * Scroll a dashboard section into view.
 *
 * Kept out of the component so `QuickNav` does no DOM work and stays testable, and
 * so a missing anchor is reported rather than silently doing nothing. The old nav
 * called `document.getElementById(...)?.scrollIntoView()` inline, so a renamed
 * section id produced a dead button with no signal anywhere.
 *
 * @param {string} sectionId
 * @param {Document} [doc]
 * @returns {boolean} Whether a matching section was found.
 */
export function scrollToSection(sectionId, doc = globalThis.document) {
  const target = doc?.getElementById(sectionId);
  if (!target) {
    reportClientError(
      new Error(`Quick nav target not found: ${sectionId}`),
      { scope: 'shell.quickNav', sectionId },
      'warning',
    );
    return false;
  }
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}
